module.exports = __webpack_public_path__ + "static/media/Acrilico (22).c41b5a23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (22).jpg
// module id = 290
// module chunks = 0